import { getCurrentRouteLocale } from "@helpers/get-current-locale";
import { DEFAULT_ROUTER_LOCALE } from "@constants/global.constants";

export function formatUrlWithLocale(url: string) {
  const locale = getCurrentRouteLocale();
  if (locale === DEFAULT_ROUTER_LOCALE) return url;
  return `/${locale}${url}`;
}
